import React, { useEffect } from 'react';
import Header from './Components/Header';
import MainHeader from './Components/MainHeader';
import Footer from './Components/Footer';
import SEOHelmet from './Components/SEOHelmet';

const ShippingPolicy = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const sectionStyle = { marginBottom: '30px' };
    const headingStyle = { color: '#a04ff4', fontSize: '1.4rem', fontWeight: '600', marginBottom: '15px' };
    const textStyle = { fontSize: '1.05rem', lineHeight: '1.8', color: '#c4c8cc' };
    const listStyle = { ...textStyle, paddingLeft: '20px', marginBottom: '15px' };

    return (
        <div style={{ backgroundColor: '#0c001f', minHeight: '100vh', width: '100%', color: '#e0e0e0', fontFamily: "'Space Grotesk', sans-serif" }}>
            <Header />
            <MainHeader />
            <SEOHelmet
                title="Shipping Policy"
                description="Octalbees offers only digital services and products. All deliverables are sent digitally via email, dashboard, or secure file links."
                path="/shipping-policy"
            />
            
            <div className="container" style={{ paddingTop: '40px', paddingBottom: '80px' }}>
                <div className="row justify-content-center">
                    <div className="col-lg-10">
                        <div className="p-md-5">
                            <div className="mb-5">
                                <h1 className="fw-bold text-center" style={{ color: '#fff', fontSize: '2.5rem' }}>Shipping & Delivery Policy</h1>
                            </div>

                            <div style={sectionStyle}>
                                <p style={{ color: '#a5b0bb', fontSize: '0.95rem', fontStyle: 'italic', marginBottom: '20px' }}>
                                    Last Updated: 29 August 2026
                                </p>
                            </div>

                            <div style={sectionStyle}>
                                <h2 style={headingStyle}>1. Primary Digital Delivery</h2>
                                <p style={textStyle}>
                                    At Octalbees, the majority of our operations revolve around digital services, software development, web solutions, and educational courses. Almost all of our deliverables—including source code, project files, course access, and digital certificates—are delivered electronically. For these digital goods, no physical shipping, handling fees, or physical delivery times apply.
                                </p>
                            </div>

                            <div style={sectionStyle}>
                                <h2 style={headingStyle}>2. Physical Shipping (On Request)</h2>
                                <p style={textStyle}>
                                    In certain cases, students or clients may request physical items, such as hard copies of completion certificates or promotional merchandise. The following rules apply to physical shipments:
                                </p>
                                <ul style={listStyle}>
                                    <li><strong>Shipping Fees:</strong> A flat additional charge of ₹250 applies to the shipping of physical certificates or standard merchandise within India.</li>
                                    <li><strong>Processing Time:</strong> Physical requests are typically processed and dispatched within 3-5 business days of the request and payment confirmation.</li>
                                    <li><strong>Delivery Time:</strong> Once dispatched, standard courier delivery times apply based on your location.</li>
                                </ul>
                            </div>

                            <div style={sectionStyle}>
                                <h2 style={headingStyle}>3. Digital Delivery Methods</h2>
                                <p style={textStyle}>
                                    All final digital deliverables, reports, source code, and assets are delivered electronically. Depending on the nature of the project or course, we use:
                                </p>
                                <ul style={listStyle}>
                                    <li>Direct email transmission to the registered email address.</li>
                                    <li>Secure cloud storage links (e.g., Google Drive, AWS, GitHub).</li>
                                    <li>Direct deployment to your provided servers or hosting environment.</li>
                                    <li>Delivery via a secure client dashboard or student portal.</li>
                                </ul>
                            </div>

                            <div style={sectionStyle}>
                                <h2 style={headingStyle}>4. Acceptance of Delivery</h2>
                                <p style={textStyle}>
                                    Upon transmission of the final digital deliverables, it is your responsibility to review and test the materials. If you experience any technical issues accessing or downloading your digital deliverables, please reach out to us immediately at <a href="mailto:info@octalbees.com" style={{ color: '#a04ff4', textDecoration: 'none', fontWeight: 'bold' }}>info@octalbees.com</a> so we can provide alternative access methods.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default ShippingPolicy;
